import React, { useEffect, useState } from "react";
import { caApi } from "../../../backend_urls/caApi";
import "../../../css/pages/ca_pages/models/ClientSearchDropdown.css";

const ClientSearchDropdown = ({ onSelect }) => {
    const [clients, setClients] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const trimmedSearch = search.trim();
        if (!trimmedSearch) {
            setClients([]);
            setLoading(false);
            return undefined;
        }

        const delay = setTimeout(async () => {
            try {
                setLoading(true);
                const response = await caApi.getCAClients(trimmedSearch);
                setClients(response.data || []);
            } catch (error) {
                console.error("Failed to search clients:", error);
                setClients([]);
            } finally { setLoading(false); }
        }, 300);

        return () => clearTimeout(delay);
    }, [search]);

    const handleSelect = (client) => {
        onSelect(client);
        setSearch(client.user_full_name || client.email || "");
        setOpen(false);
    };

    return (
        <div className="dropdown-wrapper">
            <input
                type="text"
                placeholder="Search client by name or email..."
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setOpen(true);
                }}
                onFocus={() => { if (search.trim()) { setOpen(true); } }}
            />

            {open && search.trim() && (
                <div className="dropdown-box">

                    {loading ? (
                        <div className="dropdown-item">
                            Searching clients...
                        </div>
                    ) : clients.length > 0 ? (
                        clients.map((client) => (
                            <button
                                type="button"
                                key={client.id}
                                className="dropdown-item"
                                onClick={() => handleSelect(client) }
                            >
                                <strong>
                                    {client.user_full_name}
                                </strong>

                                <small>
                                    {client.email}
                                </small>
                            </button>
                        ))
                    ) : (
                        <div className="dropdown-item">
                            No clients found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ClientSearchDropdown;
